<template>
  <div class="form">
    <div class="form__content">
      <IdentityQueueStepCounter />
      <h1 class="extra-large-headline">
        {{ $t("PageTitle.headline.proofOfAddressPageHeader") }}
      </h1>
      <p class="bodycopy">
        {{ $t("PageSubTitle.paragraph.proofOfAddressInstructions") }}
      </p>
    </div>
    <form @submit.prevent>
      <FileUploadField
        name="proofOfAddressDocument"
        label="Upload proof of address document"
        :placeholder="$t('FileUploadField.placeholder.selectOrDrag')"
        iconType="DocumentCircle"
        :errors="form.proofOfAddressDocumentErrors"
        @updateFile="updateFile"
      />

      <ButtonBase
        :isDisabled="formHasErrors || globalStore.getIsFormLoading"
        :isLoading="globalStore.getIsFormLoading"
        @onButtonClick="handleFormSubmit"
      >
        Continue
      </ButtonBase>
      <IdentityQueueNext />
    </form>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import { useGlobalStore } from "@/stores/globalStore";
import { useIdentityQueueStore } from "@/stores/identityQueueStore";

import useCustomerActions from "@/composables/api/useCustomerActions";
import useApiHelpers from "@/composables/api/helpers";

import FileUploadField from "@/components/ui/inputs/FileUploadField.vue";
import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";
import useFormValidation from "@/composables/validations/useFormValidation";
import IdentityQueueStepCounter from "@/components/layout/progress/IdentityQueueStepCounter.vue";
import IdentityQueueNext from "@/components/layout/progress/IdentityQueueNext.vue";

const route = useRoute();
const router = useRouter();
const globalStore = useGlobalStore();
const identityQueueStore = useIdentityQueueStore();
const { validateFileInput } = useFormValidation();
const { fetchCustomerId } = useCustomerActions();
const { postRequest } = useApiHelpers();

const form = ref({
  proofOfAddressDocument: [],
  proofOfAddressDocumentErrors: "",
});
const updateFile = (file) => {
  const fileValidationErrors = validateFileInput(
    "proofOfAddressDocument",
    file
  );
  form.value.proofOfAddressDocument = file;

  form.value.proofOfAddressDocumentErrors = fileValidationErrors;
};

const handleFormSubmit = async () => {
  const custId = await fetchCustomerId();
  const formData = new FormData();
  const docType = "proof_of_address";

  globalStore.setIsFormLoading(true);

  formData.set("documentFile", form.value.proofOfAddressDocument);
  formData.set("documentType", docType);
  formData.set("documentReference", custId);

  postRequest("documents", formData, () => {
    identityQueueStore.updateToNextRoute();
    identityQueueStore.fetchNextIdentityRoute(route).then((nextRoute) => {
      router.push(nextRoute);
    });
  });
};

const formHasErrors = computed(() => {
  const anyErrors = form.value.proofOfAddressDocumentErrors !== "";
  const anyFieldsEmpty = form.value.proofOfAddressDocument.length === 0;
  return anyErrors || anyFieldsEmpty;
});
</script>
<style lang="scss" scoped>
.form {
  .bodycopy {
    margin-bottom: 1rem;
    @include breakpoint($min-m) {
      margin-bottom: 1.5rem;
    }
  }
  &__selfie-instructions {
    list-style: unset;
    padding-inline: 1.5rem;

    li {
      font-size: $font-body;
      line-height: 1.5;
    }
  }
}
</style>
